import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnAddPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M4 12h16m-8-8v16"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnAddPlus;
